// extracted by mini-css-extract-plugin
export default {"icon":"DoctorCard_icon__0lUUR","name":"DoctorCard_name__KLaWB"};